module.exports = __webpack_public_path__ + "img/arrecredihome2v_2_b.b549ac06.webp";